export const getTruthyQueryParams = (queryParams) =>
  Object.fromEntries(Object.entries(queryParams).filter(([, value]) => !!value))

export const isSearchableString = (string) => !!string && string.length >= 3
